import { UserMissionCategoryPopulated } from '@gamiphy/bl/mission';
import { MissionActions } from '@gamiphy/bl/mission/enums';
import { MissionsStore } from '@gamiphy/loyalty-station-desktop/store/mission';
import { SocialAuthStore } from '@gamiphy/loyalty-station-desktop/store/socialAuth';
import { Tabs, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import React from 'react';
import { handleGoToUrl, handleOpenPopupMission } from './utils';

type MissionHandler = {
  action: (userMission: UserMissionCategoryPopulated) => void,
  hideButton?: boolean,
}

export const useMissionHandler = (userMission: UserMissionCategoryPopulated): MissionHandler | null => React.useMemo(() => {
  switch (userMission.mission.cta?.action) {
    case MissionActions.connectToFacebook:
      return {
        action: () => void SocialAuthStore.connectToFacebook(),
      };
    case MissionActions.connectToInstagram:
      return {
        action: () => void SocialAuthStore.connectToInstagram(),
      };
    case MissionActions.inviteAFriend:
      return {
        action: () => void UiStore.setTab(Tabs.Referral),
      };
    case MissionActions.goToUrl:
      return {
        action: (mission: UserMissionCategoryPopulated) => handleGoToUrl(mission),
      };
    case MissionActions.openPopupAndMarkDone:
      return {
        action: (mission: UserMissionCategoryPopulated) => handleOpenPopupMission(mission),
      };
    case MissionActions.openDatePickerAndSetBirthDate:
      return {
        action: () => MissionsStore.setBirthdayMissionPopupOpen(true),
        hideButton: !!UserStore.user?.dateOfBirth,
      };
    default:
      return null;
  }
}, [userMission, UserStore.user?.dateOfBirth]);
